<template>
  <div>
    <div class="px-5 mt-2" v-if="page !== 'carrito'">
      <div class="d-flex title-option">
        <div class="btn-home mt-2 ms-auto">
          <button
            type="button"
            class="btn btn-outline-main me-2 mt-1"
            @click="returnHome()"
          >
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
          <button
            type="button"
            class="btn btn-outline-main mt-1"
            @click="openRecipe()"
          >
            <i class="fas fa-fa-solid fa-receipt"></i> Ver Recetas
          </button>
        </div>
      </div>
      <!-- Diseño nuevo: tabla única de camas ocupadas  -->
      <!--
      <div class="table-responsive mt-3" id="div-camas-ocupadas">
        <table class="table table-bordered">
          <caption class="py-0 my-0"></caption>
          <thead class="bg-main text-white text-center">
            <tr>
              <th scope="col">Servicio</th>
              <th scope="col">Cama</th>
              <th scope="col">Paciente</th>
              <th scope="col">Acción</th>
            </tr>
          </thead>
          <tbody class="text-center">
            <tr v-if="!loadingBeds && camasOcupadas.length == 0">
              <td colspan="4">No hay camas ocupadas</td>
            </tr>
            <tr v-if="loadingBeds">
              <td colspan="4">Cargando camas...</td>
            </tr>
            <tr v-for="(item, index) in camasOcupadas" :key="index">
              <td>{{ item.servicio }}</td>
              <td>{{ item.cama }}</td>
              <td>{{ item.paciente }}</td>
              <td>
                <button
                  type="button"
                  class="btn btn-sm bg-main text-white"
                  @click="mtdRegistrarReceta(item)"
                >
                  <i class="fas fa-fa-solid fa-receipt"></i> Registrar Receta
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      -->
      <ul class="nav pb-0 mt-2" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            @click="changePage('hospi')"
            :class="{
              'item-button': true,
              'nav-link': true,
              active: page === 'hospi',
            }"
            id="home-tab"
            type="button"
          >
            <strong>HOSPITALIZACION</strong>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            @click="changePage('uci')"
            :class="{
              'item-button': true,
              'nav-link': true,
              active: page === 'uci',
            }"
            id="profile-tab"
            type="button"
          >
            <strong>UCI ADULTO</strong>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            @click="changePage('emergencia')"
            :class="{
              'item-button': true,
              'nav-link': true,
              active: page === 'emergencia',
            }"
            id="profile-tab"
            type="button"
          >
            <strong>EMERGENCIA</strong>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            @click="changePage('sop')"
            :class="{
              'item-button': true,
              'nav-link': true,
              active: page === 'sop',
            }"
            id="profile-tab"
            type="button"
          >
            <strong>SOP Y URPA</strong>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            @click="changePage('consultas')"
            :class="{
              'item-button': true,
              'nav-link': true,
              active: page === 'consultas',
            }"
            id="profile-tab"
            type="button"
          >
            <strong>CONSULTAS</strong>
          </button>
        </li>
      </ul>

      <div class="tab-content mb-3" id="myTabContent">
        <HospitalizacionVue
          v-if="page == 'hospi'"
          :page="page"
          @openCarroRegRecipe="openCarroRegRecipe"
          @mtdChangePage="mtdChangePage"
          ref="cServiceH"
        />
        <UciVue
          v-if="page == 'uci'"
          :page="page"
          @openCarroRegRecipe="openCarroRegRecipe"
          @mtdChangePage="mtdChangePage"
          ref="cServiceU"
        />
        <EmergenciaVue
          v-if="page == 'emergencia'"
          :page="page"
          @openCarroRegRecipe="openCarroRegRecipe"
          @mtdChangePage="mtdChangePage"
          ref="cServiceE"
        />
        <ConsultasVue
          v-if="page == 'consultas'"
          :page="page"
          @openCarroRegRecipe="openCarroRegRecipe"
        />
        <SopVue
          v-if="page == 'sop'"
          :page="page"
          @openCarroRegRecipe="openCarroRegRecipe"
          @mtdChangePage="mtdChangePage"
          ref="cServiceS"
        />
      </div>
    </div>
    <div v-if="page == 'carrito'">
      <cCarritoReg
        :patient_id="carrito.patient_id"
        :medical_act_id="carrito.medical_act_id"
        :hc_id="carrito.hc_id"
        :recipe_id="carrito.recipe_id"
        :pageIni="carrito.pageIni"
        @mtdBack="mtdBack"
        @mtdSendCarrito="mtdSendCarrito"
        :patient="carrito.patient"
      />
    </div>
    <div>
      <cApplication
        :title="modalApp.title"
        :boo_modal="modalApp.modal_form"
        :medical_act_id="modalApp.medical_act_id"
        :payload="modalApp.payload"
        :recipe_ids="modalApp.recipe_ids"
        :type="modalApp.type"
        :pageIni="modalApp.pageIni"
        @closeModal="closeModal"
        @updateData="mtdChangePage"
        @mtdBackApli="mtdBackApli"
      />
    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import HospitalizacionVue from "@/components/Farmacia/pages/RegRecipe/Hospitalizacion.vue";
import UciVue from "@/components/Farmacia/pages/RegRecipe/Uci.vue";
import EmergenciaVue from "@/components/Farmacia/pages/RegRecipe/Emergencia.vue";
import ConsultasVue from "@/components/Farmacia/pages/RegRecipe/Consultas.vue";
import SopVue from "@/components/Farmacia/pages/RegRecipe/Sop.vue";
import cCarritoReg from "@/components/Farmacia/Modals/RegRecipe/cCarroRegRecipe.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import cApplication from "@/components/Farmacia/Modals/RegRecipe/cApplication.vue";
export default {
  name: "regRecipe",
  components: {
    SweetAlert,
    HospitalizacionVue,
    UciVue,
    EmergenciaVue,
    ConsultasVue,
    SopVue,
    cCarritoReg,
    cApplication,
  },
  data() {
    return {
      swal: null,
      page: "hospi",
      type: null,
      // camasOcupadas: [],
      // loadingBeds: false,
      carrito: {
        recipe_id: 0,
        patient_id: null,
        medical_act_id: null,
        hc_id: null,
        pageIni: null,
        patient:""
      },
      modalApp: {
        title: "",
        modal_form: false,
        medical_act_id: null,
        payload: [],
        recipe_ids: [],
        type: null,
        pageIni: null,
      },
    };
  },
  computed: {},
  created() {},
  methods: {
    ...mapActions(["get", "post"]),
    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
    openRecipe: function () {
      this.$emit("mtdChangePage", "recetas");
    },
    mtdBack(page) {
      this.page = page;
    },

    mtdBackApli(page) {
      this.page = page;
      this.mtdService(page);
      this.closeModal();
    },

    mtdService(page) {
      let component = null;
      switch (page) {
        case "hospi":
          component = "cServiceH";
          break;
        case "uci":
          component = "cServiceU";
          break;
        case "emergencia":
          component = "cServiceE";
          break;
        case "sop":
          component = "cServiceS";
          break;
        default:
          component = null;
          break;
      }

      this.$nextTick(() => {
        if (
          component &&
          this.$refs[component] &&
          this.$refs[component].clearUp
        ) {
          this.$refs[component].clearUp();
        } else {
          console.error(`El componente ${component} no está montado`);
        }
      });
    },

    // Diseño nuevo (comentado a pedido): trae las camas ocupadas (status == 2)
    // de Hospitalización, UCI y Emergencia en una sola tabla, en vez de
    // mostrarlas por pestañas separadas.
    /*
    mtdGetOccupiedBeds: async function () {
      this.loadingBeds = true;
      const services = [
        {
          key: "hospi",
          label: "HOSPITALIZACIÓN",
          floorUrl: "/admision/floor/",
          bedUrl: "/Pharmacy/regRecipe/bedgroup/filter",
        },
        {
          key: "uci",
          label: "UCI ADULTO",
          floorUrl: "/admision/floorUci/",
          bedUrl: "/Pharmacy/regRecipe/bedgroup/filterUci",
        },
        {
          key: "emergencia",
          label: "EMERGENCIA",
          floorUrl: "/admision/floorEmergency/",
          bedUrl: "/Pharmacy/regRecipe/bedgroup/filterEmergency",
        },
      ];
      try {
        const results = await Promise.all(
          services.map((service) => this.mtdGetServiceOccupiedBeds(service))
        );
        this.camasOcupadas = results.flat();
      } catch (errors) {
        this.$refs.SweetAlert.showError(errors);
      } finally {
        this.loadingBeds = false;
      }
    },
    mtdGetServiceOccupiedBeds: async function (service) {
      const floorResponse = await this.get({
        url:
          this.$store.getters.get__url +
          service.floorUrl +
          this.$store.getters.get__campus,
        token: this.$store.getters.get__token,
      });
      const floors = floorResponse.floors || [];

      const bedgroupResponses = await Promise.all(
        floors.map((floor) =>
          this.post({
            url: this.$store.getters.get__url + service.bedUrl,
            token: this.$store.getters.get__token,
            params: { floor_id: floor.id },
          })
        )
      );

      const beds = [];
      bedgroupResponses.forEach((response) => {
        (response.bedgroups_details || []).forEach((group) => {
          (group.beds || []).forEach((bed) => {
            if (bed.status == 2) {
              beds.push({
                servicio: service.label,
                servicio_key: service.key,
                cama: bed.name,
                paciente: bed.patient,
                patient_id: bed.patient_id,
                medical_act_id: bed.medical_act_id,
                hc_id: bed.hc_id,
                recipe_ids: bed.recipe_ids || [],
              });
            }
          });
        });
      });
      return beds;
    },
    mtdRegistrarReceta: function (item) {
      if (!item.medical_act_id) {
        this.$refs.SweetAlert.showWarning("Sin Acto Medico");
        return;
      }
      const lastRecipeId = item.recipe_ids[item.recipe_ids.length - 1] ?? 0;
      this.openCarroRegRecipe(
        item.patient_id,
        item.medical_act_id,
        item.hc_id,
        lastRecipeId,
        "table",
        item.paciente,
        item.cama
      );
    },
    */

    openCarroRegRecipe: function (
      patient_id,
      medical_act_id,
      hc_id,
      recipe_id,
      page,
      patient,
      bed
    ) {
      this.carrito.pageIni = page;
      this.carrito.patient_id = patient_id;
      this.carrito.medical_act_id = medical_act_id;
      this.carrito.hc_id = hc_id;
      this.carrito.recipe_id = recipe_id ?? 0;
      this.carrito.patient = patient + " "+ bed;
      this.page = "carrito";
    },
    mtdSendCarrito: function (
      patient_id,
      medical_act_id,
      hc_id,
      recipe_id,
      carrito,
      doctor_id
    ) {
      this.post({
        url: this.$store.getters.get__url + "/Pharmacy/regRecipe/mtdAddCarrito",
        token: this.$store.getters.get__token,
        params: {
          patient_id: patient_id,
          medical_act_id: medical_act_id,
          hc_id: hc_id,
          recipe_id: recipe_id,
          carrito: carrito,
          doctor_id: doctor_id,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            // if(response.data.msj == 0) {
            //   this.$refs.SweetAlert.showSuccess("Receta Creada Exitosamente");
            // }else{
            //   this.$refs.SweetAlert.showSuccess("Medicamentos Agregados a Receta Exitosamente");
            // }
            // this.$emit("mtdChangePage", "recetas");
            this.page = this.carrito.pageIni;
            this.carrito = {
              recipe_id: 0,
              patient_id: null,
              medical_act_id: null,
              hc_id: null,
              pageIni: null,
            };
            // this.mtdGetOccupiedBeds();
            Swal.fire({
              text: "Recetas Despachadas",
              icon: "success",
              confirmButtonColor: "#900052",
            });
            window.open(
              this.$store.getters.get__url +
                "/viewpdfDocInterno/" +
                response.data.idDis,
              "_blank"
            );
          } else {
            this.$refs.SweetAlert.showError("Error");
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    //Abrir Modal
    mtdChangePage: function (type, medical_act_id, recipe_ids, page) {
      this.post({
        url:
          this.$store.getters.get__url + "/Pharmacy/regRecipe/mtdApplication",
        token: this.$store.getters.get__token,
        params: {
          medical_act_id: medical_act_id,
          recipe_ids: recipe_ids,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.modalApp = {
              title: "Aplicación de Med.",
              modal_form: true,
              medical_act_id: medical_act_id,
              payload: response.data,
              recipe_ids: recipe_ids,
              type: type,
              pageIni: page,
            };
            // console.log(this.modalApp);
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    closeModal: function () {
      this.modalApp.title = "";
      this.modalApp.modal_form = false;
      this.modalApp.medical_act_id = null;
      this.modalApp.payload = [];
      this.modalApp.recipe_ids = [];
      this.modalApp.type = null;
    },
  },
};
</script>

<style scoped>
.h4-borde {
  border-radius: 50px;
}
#myTabContent {
  border: #900052 1.9px solid;
}

.item-button {
  background: #a9a9a9 !important;
  border-radius: 10px 10px 0px 0px;
  border: none !important;
  color: white !important;
  width: 155px;
}
.item-button1 {
  background: #a9a9a9 !important;
  border-radius: 10px 10px 0px 0px;
  border: none !important;
  color: white !important;
  width: 160px !important;
}

.nav-link:hover {
  background: #900052 !important;
}
.active {
  background-color: #900052 !important ;
}
.nav-item {
  width: 159.39px;
}
</style>
